<!--
// app/components/base/baseNuxtLink.vue
-->
<script setup lang="ts">
import BaseSpinner from "~/components/base/BaseSpinner.vue";

type Props = {
  isDefault?: boolean;
  fullWidth?: boolean;
  primary?: boolean;
  emphasis?: boolean;
  secondary?: boolean;
  textLink?: boolean;
  to?: string;
  textSize?: string;
  loading?: boolean;
  target?: "_blank" | "_self" | "_parent" | "_top" | string;
};

withDefaults(defineProps<Props>(), {
  isDefault: true,
  textSize: "text-xs",
  target: "_self",
});
</script>

<template>
  <nuxt-link
    :to="to ? to : undefined"
    :target="target"
    :class="[
      'btn relative',
      textSize,
      fullWidth ? 'w-full flex items-center justify-center' : '',
      { 'btn-primary': primary },
      { 'btn-emphasis': emphasis },
      { 'btn-secondary': secondary },
      { 'btn-text': textLink },
      { 'btn-default': isDefault },
    ]"
  >
    <base-spinner size="20" class="absolute left-1/2 -ml-[10px] top-1/2 -mt-[10px]" v-if="loading" />
    <span :class="{ 'opacity-20': loading }">
      <slot></slot>
    </span>
  </nuxt-link>
</template>

<style scoped></style>
